import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import * as _ from 'lodash';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
import { IDay, IService } from './interfaces';

export declare interface IListMeta {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
};

export interface IFilter {
  page: number;
  pageSize: number;
  startDate: Date;
  endDate: Date;
  vicarId: number;
  churchId: number;
  organistId: number;
  year: number;
  sortDirection?: 'ASC' | 'DESC'
}

@Injectable()
export class LecturesService {

  public lectures$: Subject<IService[]> = new Subject();
  public days$: Subject<IDay[]> = new Subject();
  public meta$: Subject<IListMeta> = new Subject();

  constructor( private http: Http, private datePipe: DatePipe ) {
  }

  selectDaysAllFetch() {
    return this.days$.asObservable();
  }

  dispatchDaysAllFetch( filter: IFilter ): void {

    let sortDirection = '-date';
    if ( filter.sortDirection === 'ASC' ) {
      sortDirection = 'date';
    }

    let url = environment.endPoint + `days?page=${filter.page}&page_size=${filter.pageSize}&sort=${sortDirection}`;

    if ( filter.vicarId ) {
      url += `&preacherId=${filter.vicarId}`;
    }

    if ( filter.churchId ) {
      url += `&churchId=${filter.churchId}`;
    }

    if ( filter.organistId ) {
      url += `&organistId=${filter.organistId}`;
    }

    if ( filter.year ) {
      filter.startDate = new Date( `${filter.year}-01-01T00:01:00Z` );
      filter.endDate   = new Date( `${filter.year}-12-30T23:59:00Z` );
    }

    if ( filter.startDate ) {
      url += `&startDate=${this.datePipe.transform( filter.startDate, 'dd-MM-yyyy' ) }`;
    }

    if ( filter.endDate ) {
      url += `&endDate=${this.datePipe.transform( filter.endDate, 'dd-MM-yyyy' ) }`;
    }

    this.http.get( url )
    .subscribe( ( response ) => {
      const payload = <IDay[]>response.json();
      this.days$.next( payload );
      this.meta$.next( JSON.parse( response.headers.get( 'PaginationInfo' ) ) )
    } );
  }

  dispatchLectures( filter: IFilter ): void {

    let sortDirection = '-date';
    if ( filter.sortDirection === 'ASC' ) {
      sortDirection = '+date';
    }

    let url = environment.endPoint + `services?page=${filter.page}&page_size=${filter.pageSize}&sort=${sortDirection}`;

    if ( filter.vicarId ) {
      url += `&preacherId=${filter.vicarId}`;
    }

    if ( filter.churchId ) {
      url += `&churchId=${filter.churchId}`;
    }

    if ( filter.organistId ) {
      url += `&organistId=${filter.organistId}`;
    }

    if ( filter.year ) {
      filter.startDate = new Date( `${filter.year}-01-01T00:01:00Z` );
      filter.endDate   = new Date( `${filter.year}-12-30T23:59:00Z` );
    }

    if ( filter.startDate ) {
      url += `&startDate=${this.datePipe.transform( filter.startDate, 'dd-MM-yyyy' ) }`;
    }

    if ( filter.endDate ) {
      url += `&endDate=${this.datePipe.transform( filter.endDate, 'dd-MM-yyyy' ) }`;
    }

    this.http.get( url )
    .subscribe( ( response ) => {
      const payload = <IService[]>response.json();
      const grouped = _.groupBy( payload, 'dayId' )
      this.lectures$.next( grouped );
      this.meta$.next( JSON.parse( response.headers.get( 'PaginationInfo' ) ) )
    } );
  }

  selectLectures() {
    return this.lectures$;
  }

  selectDays() {
    return this.days$;
  }

  selectMeta() {
    return this.meta$;
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/lectures.service.ts